import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material'
import React from 'react'
import MySpiner from '../spiner/MySpiner'

const MyTable = ({ head, body, name, count, limit, setLimit, offset, setOffset, hidePagination, loading, isIconMore }) => {
    
  return (
    <Box sx={{ width: '100%' }} className='myTable'>
        <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {
                            isIconMore ? <TableCell></TableCell> : ''
                        }
                        {head}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        loading ? 
                            <TableRow>
                                <TableCell
                                    // colSpan={10}
                                    colSpan={'100%'}
                                >
                                    <MySpiner /> 
                                </TableCell>
                            </TableRow>
                        :
                            body
                    }
                </TableBody>
            </Table>
        </TableContainer>
        {
            hidePagination ? ''
            :
            <TablePagination
                rowsPerPageOptions={[10, 20, 25, 50, 100]}
                component="div"
                labelRowsPerPage={`К-сть ${name} на сторінці`}
                count={count}
                rowsPerPage={limit}
                page={offset}
                onPageChange={(event, newPage) => {
                    setOffset(newPage)
                }}
                onRowsPerPageChange={e => {
                    setLimit(parseInt(e.target.value, 10))
                    setOffset(0)
                }}
            />
        }
    </Box>
  )
}

export default MyTable